document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.guarantees-section');
    if (!section) return;
  
    const animatedElements = section.querySelectorAll('.guarantees-animate');
    
    // Check if IntersectionObserver is supported
    if ('IntersectionObserver' in window) {
      const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.2 // Trigger when 20% of the element is visible
      };
  
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            // Stop observing once animated
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);
  
      animatedElements.forEach(el => observer.observe(el));
    } else {
      // Fallback for browsers without IntersectionObserver support
      animatedElements.forEach(el => el.classList.add('is-visible'));
    }
  });
